import { IconButton, Toolbar, Typography } from '@mui/material';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';

import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { AppBar } from 'shared/ui/app-bar';
import { useUserAuth } from 'features/auth';
import { SearchBar } from 'entities/search';
import { useMatch } from 'react-router-dom';
import { useStateSelector } from '../store';
import { UserTopBarAvatar } from 'features/user/top-bar-avatar';
import { Notifications } from 'entities/notifications/ui';
import { useMemo } from 'react';


type Props = {
  drawerOpen: boolean;
  toggleDrawer: () => void;
}

export const TopBar = ({ drawerOpen, toggleDrawer }: Props) => {
  const { user, logout } = useUserAuth();
  const isOnSearchPage = useMatch('/search');

  return (
    <AppBar position="absolute" open={drawerOpen}>
      <Toolbar
        sx={{
          pr: '24px'
        }}
      >
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={toggleDrawer}
          sx={{
            marginRight: '36px',
            ...(drawerOpen && { display: 'none' })
          }}
        >
          <MenuOutlinedIcon />
        </IconButton>
        <Typography
          component="h1"
          variant="h6"
          color="inherit"
          noWrap
          sx={{ flexGrow: 1 }}
        >
        </Typography>

        {!isOnSearchPage && <SearchBar />}

        <Notifications />
        
        <UserTopBarAvatar />

        <IconButton color="inherit" onClick={logout}>
          <LogoutOutlinedIcon />
          {/* <NotificationsIcon /> */}
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};
